// Group the unresolved system_alerts rows into one entry per alert TYPE, so the dashboard shows a count per type
// instead of one banner per row (owner, 2026-10-03: "the alerts on the dashboard are overwhelming", T-118).
// Pure functions: no React, no network. Tested by frontend/tests/alertGroups.test.mjs (node --test).

// What the RESOLVE button pre-fills in Claude Code. Verbatim from the owner (2026-10-03); the session opens with the text
// typed but NOT sent: the owner reads it and presses Enter.
export const RESOLVE_PROMPT =
  'Fix cause of errors based on Best Practises. If there are conflicts or dangerous implications move them to the TODO list and maintain the error alert.'

// Claude Code deep link (https://code.claude.com/docs/en/deep-links). `repo` resolves to the local clone Claude Code last
// ran in; if it has never run in one, the session opens in the home directory instead (the welcome header shows which).
export const RESOLVE_REPO = 'Fredalyze/saferfunds'
export function resolveLink(prompt = RESOLVE_PROMPT, repo = RESOLVE_REPO) {
  return `claude-cli://open?repo=${repo}&q=${encodeURIComponent(prompt)}`
}

// "PARTIAL_SELL (PINS)" and "Stale data on open position: ARKF" are one type each, whatever the symbol; counts in a title
// ("1 MAIN-account position(s) with no protective stop order") do not make a new type.
export function alertTypeTitle(title) {
  return String(title || '')
    .replace(/\s*\([^)]*\)/g, '')
    .replace(/:.*$/, '')
    .replace(/\b\d+\b/g, 'N')
    .trim() || 'Alert'
}

// Best practices 3.17: alerts that differ per symbol must stay distinguishable (a different unprotected position would be
// hidden). Grouping is by type, but each group lists the distinct symbols it covers. A subject is the token in a trailing
// "(PINS)" or after a colon ("...position: ARKF"); category words such as (SYSTEM) are not symbols.
const NOT_SUBJECTS = new Set(['SYSTEM', 'MAIN', 'TIER2', 'T2', 'CRITICAL', 'WARNING'])
export function alertSubject(title) {
  const s = String(title || '')
  const m = s.match(/\(([A-Z][A-Z0-9.\-]{0,5})\)\s*$/) || s.match(/:\s*([A-Z][A-Z0-9.\-]{0,5})\s*$/)
  return m && !NOT_SUBJECTS.has(m[1]) ? m[1] : null
}

const RANK = { critical: 0, warning: 1 }

// rows: [{id, severity, source, title, detail, created_at}]. info rows get no banner and are skipped, as before.
// Returns [{key, title, source, severity, count, ids, latest, sample}] most severe first, then most numerous, then newest.
export function groupAlerts(rows) {
  const groups = new Map()
  for (const a of rows || []) {
    if (a.severity !== 'critical' && a.severity !== 'warning') continue
    const title = alertTypeTitle(a.title)
    const key = `${a.source || '?'}|${title}`
    let g = groups.get(key)
    if (!g) {
      g = { key, title, source: a.source || '?', severity: a.severity, count: 0, ids: [], latest: a.created_at || '', sample: a.title, subjects: [], details: [] }
      groups.set(key, g)
    }
    g.count += 1
    g.ids.push(a.id)
    const subj = alertSubject(a.title)
    if (subj && !g.subjects.includes(subj)) g.subjects.push(subj)
    const det = String(a.detail || '').trim().slice(0, 120)
    if (det && !g.details.includes(det) && g.details.length < 5) g.details.push(det)
    if (a.severity === 'critical') g.severity = 'critical'
    if ((a.created_at || '') > g.latest) { g.latest = a.created_at || ''; g.sample = a.title }
  }
  return [...groups.values()].sort((x, y) =>
    (RANK[x.severity] - RANK[y.severity]) || (y.count - x.count) || String(y.latest).localeCompare(String(x.latest)))
}
